import cartSummaryHtml from './cartsummary.component.html';
import './cartsummary.component.scss';

class CartSummaryController {
    constructor($scope, CartService, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.service = CartService;
        this.SnackbarService = SnackbarService;
        this.showDiscount = false;
        this.discountCode = '';
        this.discountLoading = false;
        this.discountCodeHasError = false;
    }

    $onInit() {
        if (!this.service.loaded && !this.service.loading) {
            this.service.load();
        }

        this.$scope.$watch(
            () => this.discountCode,
            () => {
                this.discountCodeHasError = false;
            }
        );
    }

    addDiscountCode() {
        if (this.discountCode.length < 1) {
            this.SnackbarService.add('Kod rabatowy nie może być pusty!', 'error', true, 2000);
            return;
        }

        this.service.addDiscountCode(this.discountCode).then(
            () => {
                this.showDiscount = false;
                this.discountCode = '';
                this.discountLoading = false;

                this.SnackbarService.add('Dodano kod rabatowy.', 'success', true, 2000);
            },
            () => {
                this.discountLoading = false;
                this.discountCodeHasError = true;
            }
        );

        this.discountLoading = true;
    }

    removeDiscountCode(discountCode) {
        this.discountLoading = true;

        this.service.removeDiscountCode(discountCode).then(
            () => {
                this.discountLoading = false;

                this.SnackbarService.add('Usunięto aktywny kod rabatowy.', 'success', true, 2000);
            },
            () => {
                this.discountLoading = false;
            }
        );
    }
}

let cartSummaryComponent = {
    bindings: {},
    template: cartSummaryHtml,
    controller: CartSummaryController
}

export default cartSummaryComponent;